// The five kinds of sponsoring entity, and what their numbers mean.
//
// The organizational relationships below are recorded precisely because the
// obvious shorthand ("SAL/Auxiliary/ALR are all sub-units of the Post") is
// WRONG in two different ways, and getting it wrong would push someone toward
// a data model this app deliberately does not have.
//
//   POST            — an independent entity with its own number.
//
//   AUXILIARY UNIT  — NOT part of the Post organizationally. A separate,
//                     affiliated organization (the American Legion Auxiliary).
//                     Typically shares the Post's local number, but is not
//                     subordinate to it.
//
//   SAL SQUADRON    — an internal PROGRAM of the Post, not a separate
//   ALR CHAPTER       organization. But each sometimes sponsors INDEPENDENTLY
//                     of the Post rather than only through it, so each is a
//                     sponsor in its own right here. Both typically share the
//                     Post's local number.
//
//   OTHER           — free text, no number. A person or a business.
//
// WHY THERE IS NO "PARENT POST" FIELD: the four numbered types all share one
// EntityNumber. The number itself identifies the local chapter/unit regardless
// of the legal or organizational relationship to the Post, so recording a
// parent would add a field that is either redundant (the number already says
// it) or wrong (the Auxiliary has no parent Post to record).

export const ENTITY_TYPES = [
  "Post",
  "Auxiliary Unit",
  "SAL Squadron",
  "ALR Chapter",
  "Other",
] as const;

export type EntityType = (typeof ENTITY_TYPES)[number];

/** Only "Other" is unnumbered — it is a person or a business, not a chapter. */
export function entityTypeHasNumber(type: string): boolean {
  return type.trim() !== "Other" && ENTITY_TYPES.includes(type.trim() as EntityType);
}

export function isEntityType(value: string): value is EntityType {
  return ENTITY_TYPES.includes(value.trim() as EntityType);
}
